import React from "react";
import styled from "styled-components";
import { mobile, mobileM, tablet } from "../../responsive";
import products from "../../products";
import AllImg from "./AllImg";
import AllImgFurniture from "./AllImgFurniture";

import AllProVideoBanner from "./AllProVideoBanner";
//
//
// ** This are the products on the AllProducts path
//
const imgFurniture =
  "https://images.pexels.com/photos/7046171/pexels-photo-7046171.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
//
const HomeWrapper = styled.div`
  background-color: "red";
  padding: 10px 0 100px 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

//
//

const GalleryWrapper = styled.div`
  width: 80%;
  padding: 10px 0 70px 0;
  /* background: green; */
  display: flex;
  justify-content: center;
  align-items: center;

  flex-direction: column;
  ${mobile({ width: "100%", padding: "5px 0 50px 0" })}
  ${mobileM({ width: "100%" })}
  ${tablet({ width: "100%" })};
`;

//
//

const GalleryProductContainer = styled.div`
  padding: 30px 0 0 0;
  grid-template-columns: repeat(4, 1fr);
  display: grid;
  grid-gap: 2em;

  /*  */
  ${mobile({
    padding: "5px",
    display: "grid",
    gridGap: "0.1em",
    gridTemplateColumns: "repeat(1, 1fr)",
  })}
  ${mobileM({
    padding: "5px",
    display: "grid",
    gridGap: "0.1em 0",
    gridTemplateColumns: "repeat(1, 1fr)",
  })}
    ${tablet({
    padding: "5px",
    display: "grid",
    gridGap: "0.1em 0",
    gridTemplateColumns: "repeat(2, 1fr)",
  })}
`;

//
//
//
const H1 = styled.h1`
  padding: 50px 0 0 0;
  font-weight: 600;
  font-size: 1.6em;
  font-family: "Poppins-Light";
  text-transform: Capitalize;
  letter-spacing: 3px;
  text-align: center;
  color: #272727f8;
  ${mobile({ fontSize: "calc(13px + 1.5vmin)" })}
  ${mobileM({ fontSize: "calc(16px + 1.5vmin)" })}
`;
const H2 = styled.h1`
  padding: 0 0 40px 0;
  line-height: 20px;
  font-weight: 600;
  font-size: 0.9em;
  font-family: "Poppins-Light";
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;

  color: #272727e6;
  ${mobile({
    padding: "0 0 40px 0",
    lineHeight: "25px",
    fontSize: "calc(10px + 1.5vmin)",
    color: "#8741125c",
    fontWeight: "500",
  })}
  ${mobileM({ fontSize: "calc(10px + 1.5vmin)" })}
`;

//
//------------- Square  -------------
//
const GalleryProductContainerSquare = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  width: 100vw;
  min-height: 70vh;

  ${mobile({ flexDirection: "column-reverse" })}
`;
const GallerySquare = styled.div`
  padding: 0 20px 0 20px;
  text-align: center;
  /* background: pink; */
  grid-template-columns: repeat(2, 1fr);
  display: grid;
  grid-gap: 0.8em;

  /*  */
  ${mobile({
    padding: "5px",
    display: "grid",
    gridGap: "0.1em",
    gridTemplateColumns: "repeat(1, 1fr)",
  })}
  ${mobileM({
    padding: "5px",
    display: "grid",
    gridGap: "0.1em 0",
    gridTemplateColumns: "repeat(1, 1fr)",
  })}
    ${tablet({
    padding: "5px",
    display: "grid",
    gridGap: "0.1em 0",
    gridTemplateColumns: "repeat(2, 1fr)",
  })}
`;
//
const LargeSquare1 = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  /* ${mobile({ minHeight: "100vh" })} */
`;
const LargeSquare2 = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  ${mobile({ display: "none" })}
  ${mobileM({ display: "none" })}
  ${tablet({ display: "none" })}
`;
//
//
const AllProducts = () => {
  return (
    <>
      {" "}
      <AllProVideoBanner />
      <HomeWrapper>
        {" "}
        {/*


        */}
        <GalleryWrapper>
          <H1>Furniture</H1>
          <H2>Orion / 22</H2>
          <GalleryProductContainerSquare>
            <LargeSquare1>
              <GallerySquare>
                {products
                  .filter((product) => product.collection === "boreal")
                  .map((product) => (
                    <div key={product._id}>
                      <AllImgFurniture product={product} />
                    </div>
                  ))}
              </GallerySquare>
            </LargeSquare1>
            {/*   */}
            <LargeSquare2
              style={{
                backgroundRepeat: "no-repeat",
                backgroundImage: `url(${imgFurniture})`,

                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
            ></LargeSquare2>
          </GalleryProductContainerSquare>
        </GalleryWrapper>{" "}
        {/*


        */}
        <GalleryWrapper>
          <H1>Dinnerware</H1>
          <H2>Borlani / 22</H2>
          <GalleryProductContainer>
            {products
              .filter((product) => product.collection === "borlani")
              .map((product) => (
                <div key={product._id}>
                  <AllImg product={product} />
                </div>
              ))}
          </GalleryProductContainer>
        </GalleryWrapper>
        {/*  */}
        <GalleryWrapper>
          <H1>Glassware</H1>
          <H2>Norla / 22</H2>
          <GalleryProductContainer>
            {products
              .filter((product) => product.collection === "norla")
              .map((product) => (
                <div key={product._id}>
                  <AllImg product={product} />
                </div>
              ))}
          </GalleryProductContainer>
        </GalleryWrapper>
      </HomeWrapper>
    </>
  );
};

export default AllProducts;
